import { createContext, useContext, useState } from "react";

const BrandModalContext = createContext(null);

export const BrandModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <BrandModalContext.Provider value={{ open, openModal: () => setOpen(true), closeModal: () => setOpen(false) }}>
      {children}
    </BrandModalContext.Provider>
  );
};

export const useBrandModal = () => useContext(BrandModalContext);
